import type { ReactNode } from 'react'
import { useChatPanelOptional } from '@/features/chat/panel/chatPanelContext'
import { useAssistantWindowInternal } from './assistantWindowContext'

/**
 * 页面主体（顶栏之下）。助手停靠时它在右侧让出面板的宽度——助手是「插进来的一块」，不是盖在页面上；
 * 浮动 / 最小化 / 关闭时 `dockInset` 为 0，页面回到全宽。必须在 AssistantWindowProvider 里面。
 * Messages 侧边栏停靠时同样让出它的宽度（两者同一时间只开一个，相加即可）。
 */
export function AssistantDockInset({ children }: { children: ReactNode }) {
  const { dockInset: assistantInset } = useAssistantWindowInternal()
  const dockInset = assistantInset + (useChatPanelOptional()?.dockInset ?? 0)
  return (
    <div className="flex-1 overflow-hidden transition-[padding] duration-200" style={{ paddingRight: dockInset }} data-assistant-dock-inset={dockInset || undefined}>
      {children}
    </div>
  )
}
